import { type CustomerDTO } from "@ifa/utils";
import { FnaSection } from "../../CustomerDetail/components/fna/FnaSection";

interface FnaViewProps {
  customer: CustomerDTO | null;
  onBack: () => void;
}

export function FnaView({ customer }: FnaViewProps) {
  return (
    <div style={{
      height: "100%",
      overflow: "auto",
    }}>
      <FnaSection customer={customer} mode="view" />
    </div>
  );
}
